module.exports = __webpack_public_path__ + "static/scale-model-of-the-greatest-escape-games-in-colorado-springs-colorado-bcd7f60973b1899e4337184f663edd87.png";